export class Variables {
  public maxFileSize: number;
  public defaultValidExtensions: string;
}

export function variables(): Variables {
    return JSON.parse(localStorage.getItem('vars'));
} 
